export const phoneStorageOptionos = [
    { value: "16gb", label: "16GB" },
    { value: "32gb", label: "32GB" },
    { value: "64gb", label: "64GB" },
    { value: "128gb", label: "128GB" },
    { value: "256gb", label: "256GB" },
    { value: "512gb", label: "512GB" },
   
  ];

  export const phoneOSOptions = [
      {value:"iOS",label:'iOS'},
      {value:"android 9",label:'Android 9'},
      {value:"android 10.1",label:'Android 10.1'},
      {value:"android 11",label:'Android 11'},
  ]

  export const phoneColorOptions = [
    {value:"Black",label:'Black'},
    {value:"Silvar",label:'Silvar'},
    {value:"White",label:'White'},
    {value:"Gold",label:'Gold'},
]

export const phoneBrandOptions = [
    {value:"apple",label:'Apple'},
    {value:"samsung",label:'Samsung'},
    {value:"huawei",label:'Huawei'},
    {value:"redmi",label:'Redmi'},
    {value:"OnePlus",label:'OnePlus'},
]

// const uploadImages = (e) => {
  
//     let files = e.target.files

//     const data = new FormData();
//     data.append('file',files)
//     data.append('upload_preset','dmdxb6ix')
    // axios.post(
    //   "https://api.cloudinary.com/v1_1/dghtzvam5/image/upload",
    //   data
    // ).then((res) => {
    //   console.log(res);
    // })
  
//   };